import { useContext, useState } from "react";
import { notifyError } from "../../../toaster/notify";
import { PostCallWithErrorResponse } from "../../../api/ApiServices";
import { AppContext } from "../../../context/AppContext";
import { ToastMsg } from "../../TostMsg";
import { Spinner } from "react-bootstrap";

export default function PriceUpdateModal({
  isOpen,
  onClose,
  categoriesData = [],
  getItemList
//   onSave,
}) {
  const [priceAction, setPriceAction] = useState("increase");
    const { sidebar, selectedStoreID,selectedRestID,ApiConfig } = useContext(AppContext);
  const [priceType, setPriceType] = useState("flat");
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);

  console.log('selectedItems--', selectedItems)
  

  if (!isOpen) return null;

  // -----------------------------
  // LOGIC
  // -----------------------------
  const toggleCategory = (id) => {
    setExpandedCategories((p) => ({ ...p, [id]: !p[id] }));
  };

  const toggleItem = (id) => {
  setSelectedItems((prev) => {
    if (prev.includes(id)) {
      // REMOVE
      return prev.filter((itemId) => itemId !== id);
    }
    // ADD
    return [...prev, id];
  });
};

 const toggleCategoryItems = (category, checked) => {
  const categoryItemIds = category.items.map((i) => i.id);

  setSelectedItems((prev) => {
    if (checked) {
      // ADD ALL (avoid duplicates)
      const merged = new Set([...prev, ...categoryItemIds]);
      return Array.from(merged);
    } else {
      // REMOVE ALL
      return prev.filter(
        (id) => !categoryItemIds.includes(id)
      );
    }
  });
};

 const toggleSelectAll = (checked) => {
  const allItemIds = categoriesData.flatMap((cat) =>
    cat.items.map((i) => i.id)
  );

  if (checked) {
    setSelectedItems(allItemIds);
  } else {
    setSelectedItems([]);
  }
};

 const isCategoryChecked = (category) =>
  category.items.every((i) =>
    selectedItems.includes(i.id)
  );

  const isCategoryIndeterminate = (category) =>
  category.items.some((i) =>
    selectedItems.includes(i.id)
  ) && !isCategoryChecked(category);


  const handleSave = () => {
    if (!amount || Number(amount) <= 0) return notifyError("Enter a valid amount");

    const items = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map(Number);

    if (!items.length) return notifyError("Select at least one item");

   setLoading(true);
   
     console.log('selectedStoreID ===>',selectedStoreID);
     
     const requestBody = JSON.stringify({ 
        item_ids : selectedItems,
        shop_id : selectedStoreID,
        change_type : priceType,
        change_action : priceAction,
        change_value : amount,

     });
   
     PostCallWithErrorResponse(ApiConfig.POST_PRICE_UPDATE, requestBody)
       .then((res) => {
         setLoading(false);
         if (res.json && res.json?.success === true) {
            getItemList();
           ToastMsg("success", res.json.message);
        
         } else {
           ToastMsg("error", res.json.message);
         }
       })
       .catch((err) => {
         setLoading(false);
     
         console.log(err);
       }).finally(()=>{
          onClose();
       });

  
  };

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* HEADER */}
        <div style={styles.header}>
          <h3 style={styles.title}>Item(s) Price Update</h3>
          <button onClick={onClose} style={styles.close}>
            ✕
          </button>
        </div>

        <div style={styles.body}>
          {/* LEFT PANEL */}
          <div style={styles.left}>
            <div style={styles.group}>
              <label style={styles.label}>Price</label>
              <div style={styles.radioRow}>
                {["increase", "decrease"].map((v) => (
                  <label key={v} style={styles.radio}>
                    <input
                      type="radio"
                      checked={priceAction === v}
                      onChange={() => setPriceAction(v)}
                    />
                    {v === "increase" ? "Increase" : "Reduce"}
                  </label>
                ))}
              </div>
            </div>

            <div style={styles.group}>
              <label style={styles.label}>By</label>
              <div style={styles.radioRow}>
                {["fixed", "percentage"].map((v) => (
                  <label key={v} style={styles.radio}>
                    <input
                      type="radio"
                      checked={priceType === v}
                      onChange={() => setPriceType(v)}
                    />
                    {v === "fixed" ? "Flat" : "Percentage"}
                  </label>
                ))}
              </div>
            </div>

            <div style={styles.group}>
              <label style={styles.label}>Amount</label>
              <input
                type="number"
                placeholder={
                  priceType === "percentage"
                    ? "Enter %"
                    : "Enter amount"
                }
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div style={styles.right}>
            <div style={styles.rightHeader}>
              <h4>Select Items</h4>
              <label style={styles.selectAll}>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    toggleSelectAll(e.target.checked)
                  }
                  style={{marginRight:'4px'}}
                />
                Select All
              </label>
            </div>

            <div style={styles.tree}>
              {categoriesData.map((cat) => (
                <div key={cat.category_id}>
                  <div style={styles.categoryRow}>
                    <span
                      style={styles.expand}
                      onClick={() =>
                        toggleCategory(cat.category_id)
                      }
                    >
                      {expandedCategories[cat.category_id]
                        ? "▾"
                        : "▸"}
                    </span>

                    <input
                      type="checkbox"
                      checked={isCategoryChecked(cat)}
                      ref={(el) => {
                        if (el)
                          el.indeterminate =
                            isCategoryIndeterminate(cat);
                      }}
                      onChange={(e) =>
                        toggleCategoryItems(
                          cat,
                          e.target.checked
                        )
                      }
                    />

                    <span style={styles.categoryName}>
                      {cat.category_name}
                    </span>
                  </div>

                  {expandedCategories[cat.category_id] &&
                    cat.items.map((item) => (
                      <div
                        key={item.id}
                        style={styles.itemRow}
                      >
                        <input
                          type="checkbox"
                         checked={selectedItems.includes(item.id)}
                          onChange={() =>
                            toggleItem(item.id)
                          }
                        />
                        <span>{item.item_name}</span>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <button onClick={onClose} style={styles.cancel}>
            Cancel
          </button>
          <button disabled={loading} onClick={handleSave} style={styles.save}>
            {loading ? <Spinner size="sm" /> : "Save Changes"} 
          </button>
        </div>
      </div>
    </div>
  );
}

// -----------------------------
// PROFESSIONAL STYLE SYSTEM
// -----------------------------
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  modal: {
    background: "#FFFFFF",
    width: "900px",
    maxHeight: "85vh",
    borderRadius: "12px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  header: {
    padding: "16px 20px",
    borderBottom: "1px solid #E6E9ED",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: 600,
  },

  close: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#999",
  },

  body: {
    padding: "20px",
    display: "flex",
    gap: "24px",
    overflow: "hidden",
  },

  left: {
    flex: "0 0 280px",
  },

  group: {
    marginBottom: "20px",
  },

  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#333",
  },

  radioRow: {
    display: "flex",
    gap: "16px",
  },

  radio: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    cursor: "pointer",
  },

  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #DADFE6",
    outline: "none",
    fontSize: "14px",
  },

  right: {
    flex: 1,
    borderLeft: "1px solid #E6E9ED",
    paddingLeft: "20px",
    display: "flex",
    flexDirection: "column",
  },

  rightHeader: {
    display: "flex",
    flexDirection : 'column',
    justifyContent: "space-between",
    alignItems: "start",
    marginBottom: "10px",
    
  },

  selectAll: {
    fontSize: "13px",
    cursor: "pointer",
    color: "#555",
    

  },

  tree: {
    overflowY: "auto",
    paddingRight: "8px",
  },

  categoryRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 0",
    fontWeight: 500,
  },

  categoryName: {
    fontSize: "14px",
    color: "#222",
  },

  expand: {
    cursor: "pointer",
    width: "18px",
    textAlign: "center",
    color: "#53B7E8",
    fontWeight: "bold",
  },

  itemRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 0 4px 24px",
    fontSize: "13px",
    color: "#444",
  },

  footer: {
    padding: "16px 20px",
    borderTop: "1px solid #E6E9ED",
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },

  cancel: {
    padding: "10px 16px",
    background: "#F3F5F7",
    border: "1px solid #DADFE6",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
  },

  save: {
    padding: "10px 20px",
    background: "#53B7E8",
    border: "none",
    borderRadius: "8px",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
  },
};
